import { SEND_SUGGEST_REQUESTS } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (termNumber: number, token: string) =>
  fetch(SEND_SUGGEST_REQUESTS(termNumber), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }).then(errorHandler)
